import React from "react";
import ItemComposer from "./item-composer";

const CollectionComposer = ({ 
    data,
    handleShowComposer,
    handleUpdateComposer
 }) => {

    return (
        <div className="relative">
            {Array.isArray(data) && data.map((item, index) => (
                <ItemComposer
                    item={item}
                    key={index}
                    index={index}
                    handleShowComposer={() => handleShowComposer(item.id)}
                    onClick={handleUpdateComposer}
                />
            ))}
        </div>
    )
}
export default CollectionComposer;
